import { LanguageCode, MarketCode } from '@tink/config/src/markets';

type MarketLangCodeUrlMap = {
  language: LanguageCode;
  termsConditionsUrl: string;
  privacyPolicyUrl: string;
};

type MarketCodeUrlMap = {
  [key in keyof typeof MarketCode]?: MarketLangCodeUrlMap[];
};

export const defaultLegalTextUrlMap: MarketLangCodeUrlMap = {
  language: LanguageCode.sv,
  termsConditionsUrl:
    'https://cdn.tink.se/legal/terms-and-conditions/terms-and-conditions-sv_SE-220521-v3.html',
  privacyPolicyUrl: 'https://cdn.tink.se/legal/privacy-policy/privacy-policy-sv_SE-200428.html',
};

// If multiple languages, then the default must be the first, since we access it with index 0
export const legalTextUrlMap: MarketCodeUrlMap = {
  [MarketCode.AT]: [
    {
      language: LanguageCode.de,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/de_AT/terms-and-conditions-de_AT-220706-v2.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/de_AT/privacy-policy-de_AT-220706.html',
    },
  ],

  [MarketCode.BE]: [
    {
      language: LanguageCode.en,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/en_BE/terms-and-conditions-en_BE-200923.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/en_BE/privacy-policy-en_BE-200923.html',
    },
    {
      language: LanguageCode.fr,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/fr_BE/terms-and-conditions-fr_BE-200923.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/fr_BE/privacy-policy-fr_BE-200923.html',
    },
    {
      language: LanguageCode.nl,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/nl_BE/terms-and-conditions-nl_BE-200923.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/nl_BE/privacy-policy-nl_BE-200923.html',
    },
  ],
  [MarketCode.CH]: [
    {
      language: LanguageCode.en,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/en_CH/terms-and-conditions-en_CH-220624.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/en_CH/privacy-policy-en_CH-220902.html',
    },
  ],
  [MarketCode.CZ]: [
    {
      language: LanguageCode.cs,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/en_CZ/terms-and-conditions-en_CZ-230227-v2.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/cs_CZ/privacy-policy-cs_CZ-230227.html',
    },
  ],
  [MarketCode.DE]: [
    {
      language: LanguageCode.de,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/de_DE/terms-and-conditiones-de_DE-230707.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/de_DE/privacy-policy-de_DE-230707.html',
    },
  ],
  [MarketCode.DK]: [
    {
      language: LanguageCode.da,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/da_DK/terms-and-conditions-da_DK-210608.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/da_DK/privacy-policy-da_DK-200810.html',
    },
  ],
  [MarketCode.EE]: [
    {
      language: LanguageCode.et,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/et_EE/terms-and-conditions-et_EE-210331.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/et_EE/privacy-policy-et_EE-200612.html',
    },
  ],
  [MarketCode.ES]: [
    {
      language: LanguageCode.es,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/es_ES/terms-and-conditions-es_ES-210608.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/es_ES/privacy-policy-es_ES-200612.html',
    },
  ],
  [MarketCode.FI]: [
    {
      language: LanguageCode.fi,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/fi_FI/terms-and-conditions-fi_FI-210608.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/fi_FI/privacy-policy-fi_FI-200810.html',
    },
  ],
  [MarketCode.FR]: [
    {
      language: LanguageCode.fr,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/fr_FR/terms-and-conditions-fr_FR-210531.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/fr_FR/privacy-policy-fr_FR-201005.html',
    },
  ],
  [MarketCode.GB]: [
    {
      language: LanguageCode.en,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/en_UK/terms-and-conditions-en_UK-220906.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/privacy-policy-en_US-200428-v2.html', // TODO: Replace US legal text
    },
  ],
  [MarketCode.IE]: [
    {
      language: LanguageCode.en,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/en_IE/terms-and-conditions-en_IE-230911.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/en_IE/privacy-policy-en_IE-230921.html',
    },
  ],
  [MarketCode.IT]: [
    {
      language: LanguageCode.it,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/it_IT/terms-and-conditions-it_IT-210531.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/it_IT/privacy-policy-it_IT-200624.html',
    },
  ],
  [MarketCode.LT]: [
    {
      language: LanguageCode.lt,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/lt_LT/terms-and-conditions-lt_LT-210331.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/lt_LT/privacy-policy-lt_LT-200612.html',
    },
  ],
  [MarketCode.LV]: [
    {
      language: LanguageCode.lv,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/lv_LV/terms-and-conditions-lv_LV-210331.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/lv_LV/privacy-policy-lv_LV-200612.html',
    },
  ],
  [MarketCode.NL]: [
    {
      language: LanguageCode.nl,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/nl_NL/terms-and-conditions-nl_NL-210608.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/nl_NL/privacy-policy-nl_NL-200624.html',
    },
  ],
  [MarketCode.NO]: [
    {
      language: LanguageCode.no,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/no_NO/terms-and-conditions-no_NO-210610-v2.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/no_NO/privacy-policy-no_NO-200810.html',
    },
  ],
  [MarketCode.PL]: [
    {
      language: LanguageCode.pl,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/pl_PL/terms-and-conditions-pl_PL-210602.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/pl_PL/privacy-policy-pl_PL-210602.html',
    },
  ],
  [MarketCode.PT]: [
    {
      language: LanguageCode.pt,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/pt_PT/terms-and-conditions-pt_PT-210531-v2.html',
      privacyPolicyUrl: 'https://cdn.tink.se/legal/privacy-policy/privacy-policy-pt_PT-200612.html',
    },
  ],
  [MarketCode.SE]: [defaultLegalTextUrlMap],
  [MarketCode.US]: [
    {
      language: LanguageCode.en,
      termsConditionsUrl:
        'https://cdn.tink.se/legal/terms-and-conditions/en_US/terms-and-conditions-en_US-230927-v2.html',
      privacyPolicyUrl:
        'https://cdn.tink.se/legal/privacy-policy/en_US/privacy-policy-en_US-230929_v2.html',
    },
  ],
};
